<template>
  <div>
    <StatusModal
      :show.sync="modals.successModal"
      :message="modal.success"
      :title="modal.successTitle"
    />
    <StatusModal
      :show.sync="modals.removeModal"
      :message="modal.remove"
      :title="modal.removeTitle"
    />
    <StatusModal
      :show.sync="modals.removeFailedModal"
      :message="modal.removeFailed"
      :title="modal.removeTitle"
    />

    <div>
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB INFORMATION
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ refno }}</p>

              <p class="new-title">Service Location</p>
              <p class="subtitle">
                {{ servicelocation }}
              </p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">
                {{ picfullname }}
              </p>

              <p class="new-title">PIC Phone No.</p>
              <p class="subtitle">
                {{ picphoneno }}
              </p>

              <p class="new-title">PIC Fax No.</p>
              <p class="subtitle">
                {{ picfaxno }}
              </p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">
                {{ picemail }}
              </p>
            </div>
          </card>
        </div>
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              DEATH CERTIFICATE
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <div v-if="displayflag" class="row">
                <div class="col-lg">
                  <input
                    type="checkbox"
                    class="rounded-checkbox"
                    id="checkbox"
                    v-model="checkedItems"
                    :value="required[0].value"
                  />&nbsp;&nbsp; {{ required[0].label }}
                </div>
              </div>

              <div v-if="displayflag" class="row">
                <div class="col-lg">
                  <div style="padding-top: 10px">
                    <div
                      class="w-100 p-4 d-flex align-items-center justify-content-center"
                      style="
                        border: 2px dashed lightgray;
                        height: 280px;
                        width: 350px;
                      "
                    >
                      <div class="col-lg-12 text-center">
                        <i
                          style="
                            color: lightgray;
                            font-size: 90px;
                            font-weight: 500;
                            margin-bottom: 10px;
                          "
                          class="tim-icons icon-cloud-upload-94"
                        ></i>

                        <p style="font-weight: 600; color: #787878">
                          Drop files to upload
                        </p>
                        <div class="row">
                          <div
                            class="col-lg text-center"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                          >
                            <p
                              style="
                                font-weight: 600;
                                color: #787878;
                                margin: 0 10px 0 0;
                              "
                            >
                              or
                            </p>
                            <label
                              class="fileinput"
                              for="cert-upload"
                              style="cursor: pointer; margin-top: 5px"
                            >
                              <p
                                style="
                                  font-weight: 600;
                                  font-size: 14px;
                                  color: #5e99ff;
                                  text-decoration: underline;
                                  margin: 0;
                                "
                              >
                                browse
                              </p>
                            </label>
                            <input
                              accept="application/pdf"
                              id="cert-upload"
                              type="file"
                              class="valid"
                              :multiple="true"
                              aria-invalid="false"
                              style="display: none"
                              v-on:change="onFileChangeCert"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      height: 100px;
                      padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px;
                    "
                    class="d-flex justify-content-center spinner"
                    v-if="certload == true"
                  >
                    <circle-8></circle-8>
                  </div>
                </div>
              </div>
              <br />
              <div
                :style="{
                  height: displayflag ? '180px' : '450px',
                  overflowY: 'auto',
                }"
                v-if="certload != true"
              >
                <div class="col-lg-12">
                  <div v-if="deathcertificate.length === 0">
                    <p
                      style="
                        color: #707070;
                        opacity: 0.7;
                        text-align: left;
                        font-size: 14px;
                        margin-bottom: -10px;
                      "
                    >
                      No file chosen
                    </p>
                  </div>
                  <div v-for="(item, index) in deathcertificate" :key="index">
                    <div class="row">
                      <div class="col-lg-2 text-center">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ index + 1 }}.
                        </p>
                      </div>
                      <div class="col-lg-7 text-left">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ item.filename }}
                        </p>
                      </div>
                      <div class="col-lg-1 text-center">
                        <a :href="item.fileurl" :download="item.filename">
                          <i
                            class="tim-icons icon-cloud-download-93 download-icon"
                          ></i>
                        </a>
                      </div>
                      <div v-if="displayflag" class="col-lg-1 text-center">
                        <i
                          class="tim-icons icon-simple-remove remove-icon"
                          @click="removeCert(item.fileid)"
                        ></i>
                      </div>
                      <div class="col-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              WEIGHT BRIDGE RECEIPT
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <div v-if="displayflag" class="row">
                <div class="col-lg">
                  <div style="padding-top: 30px">
                    <div
                      class="w-100 p-4 d-flex align-items-center justify-content-center"
                      style="
                        border: 2px dashed lightgray;
                        height: 280px;
                        width: 350px;
                      "
                    >
                      <div class="col-lg-12 text-center">
                        <i
                          style="
                            color: lightgray;
                            font-size: 90px;
                            font-weight: 500;
                            margin-bottom: 10px;
                          "
                          class="tim-icons icon-cloud-upload-94"
                        ></i>

                        <p style="font-weight: 600; color: #787878">
                          Drop files to upload
                        </p>
                        <div class="row">
                          <div
                            class="col-lg text-center"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                          >
                            <p
                              style="
                                font-weight: 600;
                                color: #787878;
                                margin: 0 10px 0 0;
                              "
                            >
                              or
                            </p>
                            <label
                              class="fileinput"
                              for="receipt-upload"
                              style="cursor: pointer; margin-top: 5px"
                            >
                              <p
                                style="
                                  font-weight: 600;
                                  font-size: 14px;
                                  color: #5e99ff;
                                  text-decoration: underline;
                                  margin: 0;
                                "
                              >
                                browse
                              </p>
                            </label>
                            <input
                              accept="application/pdf"
                              id="receipt-upload"
                              type="file"
                              class="valid"
                              :multiple="true"
                              aria-invalid="false"
                              style="display: none"
                              v-on:change="onFileChangeReceipt"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      height: 100px;
                      padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px;
                    "
                    class="d-flex justify-content-center spinner"
                    v-if="receiptload == true"
                  >
                    <circle-8></circle-8>
                  </div>
                </div>
              </div>
              <br />
              <div
                :style="{
                  height: displayflag ? '180px' : '450px',
                  overflowY: 'auto',
                }"
                class=""
                v-if="receiptload != true"
              >
                <div class="col-lg-12">
                  <div v-if="weightbridgereceipt.length === 0">
                    <p
                      style="
                        color: #707070;
                        opacity: 0.7;
                        text-align: left;
                        font-size: 14px;
                        margin-bottom: -10px;
                      "
                    >
                      No file chosen
                    </p>
                  </div>
                  <div
                    v-for="(item, index) in weightbridgereceipt"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-lg-2 text-center">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ index + 1 }}.
                        </p>
                      </div>
                      <div class="col-lg-7 text-left">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ item.filename }}
                        </p>
                      </div>
                      <div class="col-lg-1 text-center">
                        <a :href="item.fileurl" :download="item.filename">
                          <i
                            class="tim-icons icon-cloud-download-93 download-icon"
                          ></i>
                        </a>
                      </div>
                      <div v-if="displayflag" class="col-lg-1 text-center">
                        <i
                          class="tim-icons icon-simple-remove remove-icon"
                          @click="removeReceipt(item.fileid)"
                        ></i>
                      </div>
                      <div class="col-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              CONSIGNMENT NOTE
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <div v-if="displayflag" class="row">
                <div class="col-lg">
                  <div style="padding-top: 30px">
                    <div
                      class="w-100 p-4 d-flex align-items-center justify-content-center"
                      style="
                        border: 2px dashed lightgray;
                        height: 280px;
                        width: 350px;
                      "
                    >
                      <div class="col-lg-12 text-center">
                        <i
                          style="
                            color: lightgray;
                            font-size: 90px;
                            font-weight: 500;
                            margin-bottom: 10px;
                          "
                          class="tim-icons icon-cloud-upload-94"
                        ></i>

                        <p style="font-weight: 600; color: #787878">
                          Drop files to upload
                        </p>
                        <div class="row">
                          <div
                            class="col-lg text-center"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                          >
                            <p
                              style="
                                font-weight: 600;
                                color: #787878;
                                margin: 0 10px 0 0;
                              "
                            >
                              or
                            </p>
                            <label
                              class="fileinput"
                              for="cn-upload"
                              style="cursor: pointer; margin-top: 5px"
                            >
                              <p
                                style="
                                  font-weight: 600;
                                  font-size: 14px;
                                  color: #5e99ff;
                                  text-decoration: underline;
                                  margin: 0;
                                "
                              >
                                browse
                              </p>
                            </label>
                            <input
                              accept="application/pdf"
                              id="cn-upload"
                              type="file"
                              class="valid"
                              :multiple="true"
                              aria-invalid="false"
                              style="display: none"
                              v-on:change="onFileChangeCN"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      height: 100px;
                      padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px;
                    "
                    class="d-flex justify-content-center spinner"
                    v-if="cnload == true"
                  >
                    <circle-8></circle-8>
                  </div>
                </div>
              </div>
              <br />
              <div
                :style="{
                  height: displayflag ? '180px' : '450px',
                  overflowY: 'auto',
                }"
                class=""
                v-if="cnload != true"
              >
                <div class="col-lg-12">
                  <div v-if="consignmentnote.length === 0">
                    <p
                      style="
                        color: #707070;
                        opacity: 0.7;
                        text-align: left;
                        font-size: 14px;
                        margin-bottom: -10px;
                      "
                    >
                      No file chosen
                    </p>
                  </div>
                  <div v-for="(item, index) in consignmentnote" :key="index">
                    <div class="row">
                      <div class="col-lg-2 text-center">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ index + 1 }}.
                        </p>
                      </div>
                      <div class="col-lg-7 text-left">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ item.filename }}
                        </p>
                      </div>
                      <div class="col-lg-1 text-center">
                        <a :href="item.fileurl" :download="item.filename">
                          <i
                            class="tim-icons icon-cloud-download-93 download-icon"
                          ></i>
                        </a>
                      </div>
                      <div v-if="displayflag" class="col-lg-1 text-center">
                        <i
                          class="tim-icons icon-simple-remove remove-icon"
                          @click="removeCN(item.fileid)"
                        ></i>
                      </div>
                      <div class="col-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              INVOICE
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <div v-if="displayflag" class="row">
                <div class="col-lg">
                  <div style="padding-top: 30px">
                    <div
                      class="w-100 p-4 d-flex align-items-center justify-content-center"
                      style="
                        border: 2px dashed lightgray;
                        height: 280px;
                        width: 350px;
                      "
                    >
                      <div class="col-lg-12 text-center">
                        <i
                          style="
                            color: lightgray;
                            font-size: 90px;
                            font-weight: 500;
                            margin-bottom: 10px;
                          "
                          class="tim-icons icon-cloud-upload-94"
                        ></i>

                        <p style="font-weight: 600; color: #787878">
                          Drop files to upload
                        </p>
                        <div class="row">
                          <div
                            class="col-lg text-center"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                          >
                            <p
                              style="
                                font-weight: 600;
                                color: #787878;
                                margin: 0 10px 0 0;
                              "
                            >
                              or
                            </p>
                            <label
                              class="fileinput"
                              for="invoice-upload"
                              style="cursor: pointer; margin-top: 5px"
                            >
                              <p
                                style="
                                  font-weight: 600;
                                  font-size: 14px;
                                  color: #5e99ff;
                                  text-decoration: underline;
                                  margin: 0;
                                "
                              >
                                browse
                              </p>
                            </label>
                            <input
                              accept="application/pdf"
                              id="invoice-upload"
                              type="file"
                              class="valid"
                              :multiple="true"
                              aria-invalid="false"
                              style="display: none"
                              v-on:change="onFileChangeInvoice"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      height: 100px;
                      padding: 20px 20px 0px 20px;
                      margin: 30px 30px 0px 0px;
                    "
                    class="d-flex justify-content-center spinner"
                    v-if="invoiceload == true"
                  >
                    <circle-8></circle-8>
                  </div>
                </div>
              </div>
              <br />
              <div
                :style="{
                  height: displayflag ? '180px' : '450px',
                  overflowY: 'auto',
                }"
                class=""
                v-if="invoiceload != true"
              >
                <div class="col-lg-12">
                  <div v-if="invoice.length === 0">
                    <p
                      style="
                        color: #707070;
                        opacity: 0.7;
                        text-align: left;
                        font-size: 14px;
                        margin-bottom: -10px;
                      "
                    >
                      No file chosen
                    </p>
                  </div>
                  <div v-for="(item, index) in invoice" :key="index">
                    <div class="row">
                      <div class="col-lg-2 text-center">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ index + 1 }}.
                        </p>
                      </div>
                      <div class="col-lg-7 text-left">
                        <p style="color: #A5A5A5; font-size: 14px">
                          {{ item.filename }}
                        </p>
                      </div>
                      <div class="col-lg-1 text-center">
                        <a :href="item.fileurl" :download="item.filename">
                          <i
                            class="tim-icons icon-cloud-download-93 download-icon"
                          ></i>
                        </a>
                      </div>
                      <div v-if="displayflag" class="col-lg-1 text-center">
                        <i
                          class="tim-icons icon-simple-remove remove-icon"
                          @click="removeInvoice(item.fileid)"
                        ></i>
                      </div>
                      <div class="col-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <base-button type="danger" v-on:click="prevTab()">Back</base-button
          >&nbsp;
          <base-button
            v-if="displayflag"
            :disabled="cancomplete"
            type="primary"
            v-on:click="redirect"
            >Done</base-button
          >
          <base-button
            v-if="!displayflag"
            wide
            type="primary"
            @click="redirect()"
          >
            Exit
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      modal: modal,
      status: 0,
      displayflag: false,
      refno: "",
      servicelocation: "",
      picfullname: "",
      picphoneno: "",
      picfaxno: "",
      picemail: "",
      deathcertificate: [],
      weightbridgereceipt: [],
      consignmentnote: [],
      invoice: [],

      certload: false,
      receiptload: false,
      cnload: false,
      invoiceload: false,

      modals: {
        successModal: false,
        removeModal: false,
        removeFailedModal: false,
      },

      checkedItems: false,
      required: [
        { value: 0, label: "Not required" },
        {
          value: 1,
          label: "Not required",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  computed: {
    cancomplete() {
      if (!this.checkedItems)
        return (
          this.deathcertificate.length === 0 ||
          this.weightbridgereceipt.length === 0 ||
          this.consignmentnote.length === 0 ||
          this.invoice.length === 0
        );

      if (this.checkedItems)
        return (
          this.weightbridgereceipt.length === 0 ||
          this.consignmentnote.length === 0 ||
          this.invoice.length === 0
        );
    },
  },
  watch: {
    checkedItems() {
      console.log("here", this.checkedItems);
    },
  },
  methods: {
    redirect() {
      this.$router.push("/Vendor/Job");
    },
    completeJob() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.outgoingid +
            "/complete"
        )
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Completing job success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                this.redirect();
              }
            });
          } else {
            console.log("job not complete", response);
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Completing job failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },
    prevTab() {
      let parameter = {
        step: "3",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "3",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        return res;
      });
    },

    getData() {
      this.deathcertificate = [];
      this.weightbridgereceipt = [];
      this.consignmentnote = [];
      this.invoice = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.outgoingid)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            this.refno = response.reference_number;
            this.servicelocation = response.service_location.location;
            this.picfullname = response.assign_to_afes.user_name;
            this.picphoneno =
              response.assign_to_afes.phone_number == null ||
              response.assign_to_afes.phone_number == ""
                ? "N/A"
                : response.assign_to_afes.phone_number;
            this.picfaxno =
              response.assign_to_afes.fax_number == null ||
              response.assign_to_afes.fax_number == ""
                ? "N/A"
                : response.assign_to_afes.fax_number;
            this.picemail =
              response.assign_to_afes.email == null ||
              response.assign_to_afes.email == ""
                ? "N/A"
                : response.assign_to_afes.email;
            this.status = response.status.status;

            if (this.$route.params.action == "edit" && this.status == 3) {
              this.displayflag = true;
            }

            if (response.death_certificate != null)
              for (var i = 0; i < response.death_certificate.length; i++) {
                let obj = {
                  filename: response.death_certificate[i].meta.filename,
                  fileurl: response.death_certificate[i].url,
                  fileid: response.death_certificate[i].document_id,
                };
                this.deathcertificate.push(obj);
              }

            if (response.weight_bridge != null)
              for (var i = 0; i < response.weight_bridge.length; i++) {
                let obj = {
                  filename: response.weight_bridge[i].meta.filename,
                  fileurl: response.weight_bridge[i].url,
                  fileid: response.weight_bridge[i].document_id,
                };
                this.weightbridgereceipt.push(obj);
              }

            if (response.consignment_note != null)
              for (var i = 0; i < response.consignment_note.length; i++) {
                let obj = {
                  filename: response.consignment_note[i].meta.filename,
                  fileurl: response.consignment_note[i].url,
                  fileid: response.consignment_note[i].document_id,
                };
                this.consignmentnote.push(obj);
              }

            if (response.invoice != null)
              for (var i = 0; i < response.invoice.length; i++) {
                let obj = {
                  filename: response.invoice[i].meta.filename,
                  fileurl: response.invoice[i].url,
                  fileid: response.invoice[i].document_id,
                };
                this.invoice.push(obj);
              }
          }
        });
    },

    onFileChangeCert(event) {
      this.certload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        const uploadPromises = [];

        this.certload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/death-certificate",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            t.value = "";
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.certload = false;
          });
      } else {
      }
    },

    removeCert(id) {
      console.log(
        ":10001/api/v1/outgoing/waste/" +
          this.$route.params.outgoingid +
          "/document/death-certificate/" +
          id
      );
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log("result", result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/death-certificate/" +
                id
            )
            .then((res) => {
              console.log("satu");
              if (!res.error) {
                console.log("dua");

                let response = res.message;
                console.log(response);
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                console.log("tigs");

                let response = res.message;
                this.modals.removeFailedModal = true;
              }
              console.log("tiga");
            });
          console.log("empat");
        }
        console.log("lima");
      });
      console.log("enam");
    },

    onFileChangeReceipt(event) {
      this.receiptload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        const uploadPromises = [];

        this.receiptload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/weight-bridge",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            t.value = "";
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.receiptload = false;
          });
      } else {
      }
    },

    removeReceipt(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/weight-bridge/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                let response = res.message;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeCN(event) {
      this.cnload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        const uploadPromises = [];

        this.cnload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/consignment-note",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            t.value = "";
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.cnload = false;
          });
      } else {
      }
    },

    removeCN(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/consignment-note/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                let response = res.message;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeInvoice(event) {
      this.invoiceload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        const uploadPromises = [];

        this.invoiceload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("documents", input);

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/invoice",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });
              }
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            t.value = "";
          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
          })
          .finally(() => {
            this.invoiceload = false;
          });
      } else {
      }
    },

    removeInvoice(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.outgoingid +
                "/document/invoice/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData(this.refno);
                }, 1000);
              } else {
                let response = res.message;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  border-radius: 6px;
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
</style>
